// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { z } from 'zod';
/** Represents the enum public.incident_severity_enum */
var IncidentSeverityEnum;
(function (IncidentSeverityEnum) {
    IncidentSeverityEnum["MINOR"] = "MINOR";
    IncidentSeverityEnum["MODERATE"] = "MODERATE";
    IncidentSeverityEnum["MAJOR"] = "MAJOR";
})(IncidentSeverityEnum || (IncidentSeverityEnum = {}));
;
export default IncidentSeverityEnum;
/** Zod schema for incident_severity_enum */
export const incidentSeverityEnum = z.nativeEnum(IncidentSeverityEnum);
//# sourceMappingURL=IncidentSeverityEnum.js.map